import { getApiBaseUrl } from './api';

/**
 * Base URL for unauthenticated `/api/public/*` endpoints (no JWT).
 * Uses the same base resolution as the main API client (proxy, __ERP4C_API_BASE__, REACT_APP_API_URL).
 */
export function getPublicApiBase() {
  const base = getApiBaseUrl().replace(/\/+$/, '');
  return `${base}/public`;
}

export function publicApiUrl(path) {
  const base = getPublicApiBase().replace(/\/+$/, '');
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${base}${p}`;
}
